import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
//import LanguageDetector from 'i18next-browser-languagedetector';  // Optional for language detection
import bs from './lang/bs.json';
import cr from './lang/cr.json';
import sr from './lang/sr.json';
import AuthService from 'services/AuthService';

const savedLang = AuthService.getLanguageCode();


i18n
  //.use(LanguageDetector) // Optional: Detects the user's language
  .use(initReactI18next) 
  .init({
    resources: {
        bs: {
        translation: bs
      },
      cr: {
        translation: cr
      },
      sr: {
        translation: sr
      }
    },
    lng: savedLang,
    fallbackLng: 'bs',
    interpolation: {
      escapeValue: false 
    }
  });

export default i18n;
